import React from 'react';

const CustomChatBotIcon = ({ className, style }) => {
  return (
    <svg 
      version="1.1" 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      x="0px" 
      y="0px"
      viewBox="0 0 600 600" 
      enableBackground="new 0 0 600 600" 
      xmlSpace="preserve"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', fill: 'currentColor', ...style }}
    >
      <g transform="translate(105, 105) scale(0.65)">
        {/* Headset & Mic Path */}
        <path 
          fill="currentColor" 
          opacity="1.000000" 
          stroke="none" 
          d="M363.999939,471.736145 
             C337.337280,471.731720 311.174622,471.727600 285.011963,471.723114 
             C283.512207,471.722839 282.012085,471.739441 280.512726,471.713623 
             C273.525299,471.593414 266.420929,471.151642 262.806458,463.970245 
             C258.951385,456.310760 261.207062,448.951935 265.791016,442.353119 
             C270.461731,435.629395 277.243866,432.261444 285.388275,432.118317 
             C295.716827,431.936768 306.051910,431.992340 316.382416,432.104889 
             C323.220551,432.179382 329.133789,434.814362 333.534973,440.009033 
             C335.621613,442.471924 337.777191,443.144745 340.807251,443.139771 
             C353.303986,443.119324 365.820465,442.923523 378.293549,443.532532 
             C398.051453,444.497345 413.764587,436.613251 425.984406,421.859375 
             C442.851318,401.494690 458.739136,352.063507 458.739136,352.063507 
             C476.548706,266.346069 422.394897,182.189728 336.962799,162.322357 
             C248.634415,141.781448 159.762283,199.693558 142.847412,288.865784 
             C135.485703,327.675323 141.616684,364.325134 160.761490,398.838257 
             C165.630325,407.615540 163.730316,415.454681 155.739883,419.684662 
             C149.161148,423.167328 141.816422,421.481079 137.757538,415.182251 
             C135.068085,411.008575 133.863998,405.049957 130.187851,402.579895 
             C126.725182,400.253265 120.827873,401.841125 116.118240,401.029907 
             C93.189980,397.080536 75.413277,376.880432 74.986824,353.611847 
             C74.568573,330.790527 74.495300,307.946350 75.008850,285.128815 
             C75.609451,258.443695 99.176872,236.422562 125.860641,237.141342 
             C129.683594,237.244324 131.219925,235.975266 132.932541,232.809860 
             C165.143066,173.275146 214.916443,138.494141 282.140503,131.420166 
             C361.134918,123.107574 433.021667,163.343552 469.626831,233.854568 
             C470.161469,234.884460 470.720032,235.901917 471.380707,237.136871 
             C485.014465,236.130585 497.445709,239.563278 508.128021,248.255630 
             C520.158813,258.045258 526.782715,270.807129 526.991638,286.348694 
             C527.289429,308.507843 527.286743,330.676849 527.005310,352.836456 
             C526.657898,380.187866 502.975616,402.734985 475.604370,401.873810 
             C471.936127,401.758392 470.390381,402.884247 468.922089,406.005402 
             C461.878632,420.977783 453.720245,435.212250 441.679535,446.922974 
             C424.889038,463.253418 405.037567,471.897064 381.496704,471.742096 
             C375.831360,471.704803 370.165527,471.736450 363.999939,471.736145 
             Z"
        />
        
        {/* Face Mask / Goggles Path (with transparent eyes using evenodd fillRule) */}
        <path 
          fill="currentColor" 
          opacity="1.000000" 
          stroke="none" 
          fillRule="evenodd"
          d="M172.691162,339.327942 
             C168.780060,296.777222 181.691162,260.463501 210.617355,229.822037 
             C219.992172,219.891327 232.142990,218.289169 244.788391,220.573242 
             C257.206848,222.816345 269.451904,226.014557 281.781738,228.754471 
             C299.513367,232.694733 316.799133,229.881363 334.104187,225.676178 
             C344.085663,223.250626 354.233673,221.200363 364.427246,220.039978 
             C375.894623,218.734604 385.659210,223.141922 393.308380,231.843628 
             C428.479950,271.854858 438.518555,317.362366 423.069977,368.411957 
             C422.781738,369.364441 422.409637,370.293854 422.037689,371.218353 
             C416.308624,385.456177 411.608612,389.230530 396.390686,387.817596 
             C382.866241,386.561920 369.352570,384.110657 356.122040,380.973114 
             C317.046844,371.706604 278.295441,373.001160 239.442657,382.314331 
             C227.849426,385.093292 215.870560,386.298187 204.043213,388.054688 
             C194.481369,389.474731 188.153122,384.635529 183.601196,376.830383 
             C176.925873,365.384247 174.222122,352.757507 172.691162,339.327942 
             Z
             M226.422501,326.330475 
             C236.080048,329.501129 244.594223,327.389404 251.435196,320.057800 
             C257.839508,313.194214 259.506683,304.968018 256.280212,296.016846 
             C252.679367,286.027100 242.919357,279.761749 232.562119,280.635254 
             C221.642258,281.556213 212.776520,289.354736 211.017868,299.586029 
             C209.020813,311.204254 214.335541,320.809753 226.422501,326.330475 
             Z
             M388.945374,293.814362 
             C388.170227,292.539062 387.491974,291.191559 386.604492,289.999908 
             C380.021149,281.160187 368.114899,278.103668 358.048523,282.622223 
             C348.127686,287.075470 342.370636,298.042511 344.528839,308.376953 
             C347.444031,322.336243 360.707794,330.582062 374.224701,326.838257 
             C387.854889,323.063080 394.537842,308.683044 388.945374,293.814362 
             Z"
        />
      </g>
    </svg>
  );
};

export default CustomChatBotIcon;
